var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.invoices-folders'),"name":"invoicesFolders","url":_vm.$listRoutes.invoicesFolders,"table":_vm.invoicesFolders,"filters":_vm.invoicesFoldersFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }